import { useEffect } from 'react';
import { authFetch } from '../utils/authUtils';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Silently loads the user's active cosmetic theme from /auth/me and applies it
 * to <body data-theme="...">. Fails quietly if the user is unauthenticated.
 *
 * Also listens to `theme-changed` window events (dispatched after shop redeem)
 * so freshly-bought themes apply without a page refresh.
 */
const ThemeLoader = () => {
  useEffect(() => {
    let canceled = false;

    const load = async () => {
      try {
        const res = await authFetch(`${BACKEND_URL}/api/auth/me`);
        if (!res.ok || canceled) return;
        const me = await res.json();
        const theme = me?.active_theme;
        if (theme) {
          document.body.setAttribute('data-theme', theme);
        } else {
          document.body.removeAttribute('data-theme');
        }
      } catch (_) {
        // Ignore — user may just be logged out.
      }
    };

    load();

    const onThemeChange = () => load();
    window.addEventListener('theme-changed', onThemeChange);
    return () => {
      canceled = true;
      window.removeEventListener('theme-changed', onThemeChange);
    };
  }, []);

  return null;
};

export default ThemeLoader;
